import { call, put, takeLatest, select } from 'redux-saga/effects';

import { types } from '../constants';
import * as companiesApi from '../api/companies';
import { submitMode } from '../constants';

function* getLoggedInUserId() {
  const extractLoggedInUserId = (state) => state.users.user.item;

  const loggedInUser = yield select(extractLoggedInUserId);
  const loggedInUserId = loggedInUser && loggedInUser.id;
  return loggedInUserId;
}

function* watchFetchAllCompanies() {
  try {
    const loggedInUserId = yield getLoggedInUserId();
    yield put({ type: types.START_FETCH_ALL_COMPANIES });
    const { jsonData } = yield call(
      companiesApi.getAllCompanies,
      loggedInUserId
    );
    yield put({
      type: types.FETCH_ALL_COMPANIES_SUCCESS,
      allCompanies: jsonData
    });
  } catch (e) {
    yield resolveError(types.FETCH_ALL_COMPANIES_FAILURE, e);
  } finally {
    yield put({ type: types.FETCH_ALL_COMPANIES_FINISHED });
  }
}

function* watchCreateEditCompany({ company, mode }) {
  try {
    const loggedInUserId = yield getLoggedInUserId();
    yield put({ type: types.START_SUBMIT_COMPANY });
    const { jsonData } =
      mode === submitMode.CREATE
        ? yield call(companiesApi.createCompany, company, loggedInUserId)
        : yield call(companiesApi.editCompany, company, loggedInUserId);

    yield put({
      type: types.SUBMIT_COMPANY_SUCCESS,
      submittedCompany: jsonData
    });

    if (mode === submitMode.CREATE) {
      yield put({ type: types.OPEN_CREATE_COMPANY_DIALOG, open: false });
    } else {
      yield put({ type: types.OPEN_EDIT_COMPANY_DIALOG, open: false });
      yield put({
        type: types.DEACTIVATE_OR_DELETE_COMPANY_DIALOG,
        open: false,
        companyId: 0,
        status: 0
      });
    }
  } catch (e) {
    yield resolveError(types.SUBMIT_COMPANY_FAILURE, e);
  } finally {
    yield put({ type: types.SUBMIT_COMPANY_FINISHED });
  }
}

function* watchDeleteOrDeactiveCompany({ company }) {
  try {
    const loggedInUserId = yield getLoggedInUserId();
    yield put({ type: types.START_SUBMIT_COMPANY });
    const { jsonData } = yield call(
      companiesApi.editCompany,
      company,
      loggedInUserId
    );

    yield put({
      type: types.SUBMIT_COMPANY_SUCCESS,
      submittedCompany: jsonData
    });

    yield put({ type: types.FETCH_ALL_COMPANIES });

    yield put({
      type: types.DEACTIVATE_OR_DELETE_COMPANY_DIALOG,
      open: false,
      companyId: 0,
      status: 0
    });
  } catch (e) {
    yield resolveError(types.SUBMIT_COMPANY_FAILURE, e);
  } finally {
    yield put({ type: types.SUBMIT_COMPANY_FINISHED });
  }
}
//This is used to catch all the errors in case of request unsuccessful, and will extract the actual error message.
function* resolveError(type, error) {
  let errorMessageCaptured = false;
  let completeErrorMessage = {};
  if (!error.ok) {
    try {
      const clone = error.clone();
      yield clone.text().then((text) => {
        completeErrorMessage = JSON.parse(text);
        errorMessageCaptured = true;
      });
    } catch (err) {
      errorMessageCaptured = true;
      completeErrorMessage = err;
    }

    if (errorMessageCaptured) {
      const errorMessage = extractErrorMessage(completeErrorMessage);
      yield put({ type, errorMessage });
    }
  }
}

function extractErrorMessage(completeErrorMessage) {
  let errorMessage = '';

  try {
    const message = completeErrorMessage.exceptionMessage
      ? completeErrorMessage.exceptionMessage.split('Content:')[1]
      : completeErrorMessage.messageDetail;

    errorMessage = JSON.parse(message).errorMessage;
    if (!errorMessage) {
      errorMessage = 'An error occured';
    }
  } catch (error) {
    errorMessage = 'An error occured';
  }

  return errorMessage;
}

export default function* companiesWatcher() {
  yield takeLatest(types.FETCH_ALL_COMPANIES, watchFetchAllCompanies);
  yield takeLatest(types.SUBMIT_COMPANY, watchCreateEditCompany);
  yield takeLatest(
    types.DEACTIVATE_OR_DELETE_COMPANY,
    watchDeleteOrDeactiveCompany
  );
}
